// shared/serverFetch.ts
export function getOptimizedImageUrl(
    src: string,
    width = 1600,
    quality = 80
) {
    // src should be something like "/assets/data/imgs/projects/foo.jpg"
    return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality}`;
}


export const consts = {
    PADDING: 5,
    PADDING_SMALL: 2,
    IMAGE_QUALITY: 90
}

// hero icons
import console from '@/public/assets/imgs/new/icons/hero/console.svg';
import worldWideWeb from '@/public/assets/imgs/new/icons/hero/world-wide-web.svg';
// about us icons
import crossPlatformGameDev from '@/public/assets/imgs/new/icons/about/cross-platform.svg';
import robustWebInfrastructure from '@/public/assets/imgs/new/icons/about/infrastructure.svg';
// gaming services icons
import art from '@/public/assets/imgs/new/icons/gaming/police.svg';
import gameDesign from '@/public/assets/imgs/new/icons/gaming/tactics.svg';
import sfxMusic from '@/public/assets/imgs/new/icons/gaming/music.svg';
import programming from '@/public/assets/imgs/new/icons/gaming/programming-2.svg';
import porting from '@/public/assets/imgs/new/icons/gaming/game-console.svg';
import publishing from '@/public/assets/imgs/new/icons/gaming/publishing.svg';
// web services icons
import commerce from '@/public/assets/imgs/new/icons/web/shopping-bag.svg';
import brands from '@/public/assets/imgs/new/icons/web/loyalty-program.svg';
import dashboards from '@/public/assets/imgs/new/icons/web/dashboard.svg';
import multiplayer from '@/public/assets/imgs/new/icons/web/multiplayer.svg';
import analytics from '@/public/assets/imgs/new/icons/web/analysis.svg';
import hosting from '@/public/assets/imgs/new/icons/web/server.svg';
// faq icons
import inHouse from '@/public/assets/imgs/new/icons/faq/inventory-management.svg';
import fast from '@/public/assets/imgs/new/icons/faq/fast-time.svg';
import experts from '@/public/assets/imgs/new/icons/faq/rating-stars.svg';
// contact icons
import contact from '@/public/assets/imgs/new/icons/contact/email.svg';
import collaborate from '@/public/assets/imgs/new/icons/contact/collaboration.svg';
import worldwide from '@/public/assets/imgs/new/icons/contact/team.svg';
import schedule from '@/public/assets/imgs/new/icons/contact/schedule.svg';
// perks icons
import experience from '@/public/assets/imgs/new/icons/perks/leadership.svg';
import powerhouse from '@/public/assets/imgs/new/icons/perks/protest.svg';
import collaborate2 from '@/public/assets/imgs/new/icons/perks/collaboration.svg';
import fullCycle from '@/public/assets/imgs/new/icons/perks/continuous.svg';
import multiplatform from '@/public/assets/imgs/new/icons/perks/cross-platform.svg';
import postLaunchSupport from '@/public/assets/imgs/new/icons/perks/shield.svg';

export const icons = {
    //hero
    console,
    worldWideWeb,
    // about us
    crossPlatformGameDev,
    robustWebInfrastructure,
    // game services
    art,
    gameDesign,
    sfxMusic,
    programming,
    porting,
    publishing,
    // web services
    commerce,
    brands,
    dashboards,
    multiplayer,
    analytics,
    hosting,
    // faq
    inHouse,
    fast,
    experts,
    // contact us
    contact,
    collaborate,
    worldwide,
    schedule,
    //perks
    experience,
    powerhouse,
    collaborate2,
    fullCycle,
    multiplatform,
    postLaunchSupport

}